<div class="row" *ngIf="editor">
  <div class="col-4"><label>{{title}}</label></div>
  <div class="col-8">
    <div class="form-group">
      <div [ngClass]="(disabled)? 'container disabled': 'container'">
        <div style="display:flex;flex-direction:row;" *ngFor="let item of array; index as idx">
          <button *ngIf="!disabled" class="nrk-doc-button" (click)="remove(item)">-</button>
          <ng-container *ngIf="this.value && this.value[0]?.id !== dummyId">
            <ngx-doc-form-checkbox style="padding-top:5px;" class="fullwidth" [label]="item.name" [(value)]="value[idx].checked" [disabled]="disabled"></ngx-doc-form-checkbox>
          </ng-container>
          <ng-container *ngIf="this.value && this.value[0]?.id === dummyId">
            <span  style="padding-top:5px;">{{item.name}}</span>
          </ng-container>
        </div>
        <div *ngIf="!disabled && this.value && this.value[0]?.id !== dummyId">
          <div class="addfield"><button class="nrk-doc-button" (click)="expandSelect()">+</button></div>
          <div class="addfield" style="padding-top:2px;margin-bottom:-2px">
            <ngx-doc-form-filter-select #business
              class="filter-select form-control form-control-sm"
              [disabled]="disabled"
              [noBorder]="false"
              [noClear]="true" 
              [placeholder]="placeholder || title" 
              [clearOnSelect]="true" 
              [options]="_options" 
              [(value)]="selected" 
              (valueChange)="add()">
            </ngx-doc-form-filter-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!editor">
  <div *ngFor="let item of array">{{item.name}}</div>
</div>

